import React from "react";
import { SkedIcon, TooltipWrapper } from "ui";
import _ from "lodash";

const PostType = ({
  type,
  size,
  color,
  className,
  isInstagram,
  videoPostType,
  isFacebook,
}) => {
  let displayType = _.capitalize(type);
  if (type === "multiMedia") {
    displayType = "Carousel";
  }

  let typeIcon = null;
  let iconSize = size || "20";
  switch (type) {
    case "text": {
      typeIcon = "icon-post-text";
      break;
    }
    case "image":
    case "photo": {
      typeIcon = "icon-post-image";
      break;
    }
    case "video":
    case "fb-reel":
    case "reel": {
      // Show reel icon when videoPostType is "reel" and platform supports reels
      const shouldShowReelIcon =
        (videoPostType === "reel" || type === "fb-reel") &&
        (isInstagram || isFacebook);
      typeIcon = shouldShowReelIcon
        ? "icon-post-reel"
        : isInstagram
          ? "icon-post-reel"
          : "icon-post-video";

      if (shouldShowReelIcon) {
        displayType = isInstagram ? "Reel" : "Reel";
      } else {
        displayType = isInstagram ? "Video/Reel" : "Video";
      }
      break;
    }
    case "multiMedia": {
      typeIcon = "icon-post-carousel";
      break;
    }
    case "igtv": {
      typeIcon = "icon-post-igtv";
      displayType = "IGTV";
      break;
    }
    case "document": {
      typeIcon = "icon-post-document";
      displayType = "Document/PDF";
      break;
    }
    case "story": {
      typeIcon = "icon-post-story";
      break;
    }
  }

  if (typeIcon === null) {
    <div className="flex justify-center items-center border border-gray-500 border-solid rounded-lg font-bold p-2 text-gray-400 min-w-50px cursor-default">
      {displayType}
    </div>;
  }

  return (
    <TooltipWrapper placement="top" tooltip={displayType}>
      <div className={`flex items-center text-gray-500 ${className}`}>
        <SkedIcon icon={typeIcon} size={iconSize} color={color} />
      </div>
    </TooltipWrapper>
  );
};

export default PostType;
